export enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  ACCENT = "accent",
  SHADOW = "shadow",
  GHOST = "ghost",
  DANGER = "danger",
  SUCCESS = "success",
  WARNING = "warning",
}

export enum ButtonIconType {
  DEFAULT = "default",
  CORE_BLUE = "core-blue",
  DANGER = "danger",
  WARNING = "warning",
  SUCCESS = "success",
  FEATURE = "feature",
  INFO = "info",
}

export enum ButtonIconContainerColor {
  CORE_SILVER = "core-silver",
  CORE_BLUE = "core-blue",
  DANGER = "danger",
  WARNING = "warning",
  SUCCESS = "success",
  FEATURE = "feature",
  INFO = "info",
}
